import { lazy, Suspense } from 'react'

import PreloaderPage from '../../components/UI/PreloaderPage/PreloaderPage'

const InvestmentPage = lazy(() => import('./InvestmentPage'))

export default function InvestmentPageLazy() {
  return (
    <Suspense fallback={<PreloaderPage />}>
      <InvestmentPage />
    </Suspense>
  )
}
